export default "__VITE_ASSET__Dvajct8s__"